<template>
  <div class="main-container">
    
    <router-view v-slot="{ Component }" :key="router.currentRoute.value.fullPath">
      <component :is="Component" />
    </router-view>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
const router = useRouter()
</script>